export const TESTCOLOR_CANDIDATE = '#bbff6080';
export const TESTCOLOR_ACTIVE = '#addcff80';
